var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"mr-2",class:_vm.status.icon}),_vm._v(" "+_vm._s(_vm.status.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }